import { render } from "./CompanySettingsList.vue?vue&type=template&id=58f66108"
import script from "./CompanySettingsList.vue?vue&type=script&lang=js"
export * from "./CompanySettingsList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__